import * as TRIGGERACTIONS from './triggerActions.constants';
import { TriggerActionStoreItem } from '../Store';
import { ACTION_DELETE_SUCCESS } from '../actions/actions.constants';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

export function triggerActionsReducer(state: TriggerActionStoreItem = { isLoaded: false, isLoading: false, hasError: false, list: [] }, action: { type: string, payload: any }) {
    let newState = state;
    const { type, payload } = action;
    switch (type) {
        case TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD:
        case TRIGGERACTIONS.TRIGGER_ACTION_ADD:
        case TRIGGERACTIONS.TRIGGER_ACTION_DELETE:
            newState = (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
            break;
        case TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD_SUCCESS:
            newState = {
                isLoading: false,
                isLoaded: true,
                hasError: false,
                list: payload
            };
            break;
        case TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD_ERROR:
        case TRIGGERACTIONS.TRIGGER_ACTION_ADD_ERROR:
        case TRIGGERACTIONS.TRIGGER_ACTION_DELETE_ERROR:
            newState = (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
            break;
        case TRIGGERACTIONS.TRIGGER_ACTION_ADD_SUCCESS:
            newState = {
                isLoading: false,
                isLoaded: true,
                hasError: false,
                list: state.list.concat([payload])
            };
            break;
        case TRIGGERACTIONS.TRIGGER_ACTION_DELETE_SUCCESS:
            const removed = state.list.filter(a => a.triggerGuid === payload.triggerGuid && a.actionGuid === payload.actionGuid);
            const kept = state.list.filter(d => removed.indexOf(d) < 0);
            newState = {
                isLoading: false,
                isLoaded: true,
                hasError: false,
                list: kept
            };
            break;
        case ACTION_DELETE_SUCCESS:
            newState = {
                isLoading: false,
                isLoaded: true,
                hasError: false,
                list: state.list.filter(a => a.actionGuid !== payload.guid)
            };
            break;
        case APPLICATION_DISCONNECTED:
            newState = {
                isLoaded: false,
                isLoading: false,
                hasError: false,
                list: []
            };
            break;
    }
    return newState;
}
